import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* createShopifyToken({ payload: { values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.shopify.create_token, data: values });

    onSuccess && onSuccess();
    yield put(actions.createShopifyTokenDone(data));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.createShopifyTokenFailed,
      handledErrors,
      endpoint: api.shopify.create_token.url
    });
  }
}

export const createShopifyTokenSaga = takeEvery(types.CREATE_SHOPIFY_TOKEN_REQUEST, createShopifyToken);